import state from './moduleAppointmentState.js';
import mutations from './moduleAppointmentMutations.js';
import actions from './moduleAppointmentActions.js';
import getters from './moduleAppointmentGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
